import React, { createContext, useReducer } from "react";

import { FC_FLOW_PRE_URL, FC_FLOW_POS_URL } from "./services/api";
import { PROMO_CODE_PRE, PROMO_CODE_POS } from "./constants/Plans";

export const initialState = {
  loading: true,
  plans: [
    {
      percentualDescontoTarifa: 100,
      valorFixoDescontoTarifa: null,
      numeroMesesBonificacao: 9,
      descSubProdLonga: "TOTAL PRE PAGO RECARGA AUTOMATICA",
      codSubProduto: "002",
      qtdContasDireitoUtilizarCodPromo: null,
      dataInicialValidadeCodPromo: "20181015000000000",
      dataFinalValidadeCodPromo: "20501015000000000",
      pacoteDefaultBonificacaoSubProd: false,
      descBonificacaoLonga: "BB VAREJO - CRED BON - 5M PF",
      codPromocional: "VELOEBBVAR",
      descBonificacaoCurta: "BBVAR - CRED BON - 5M PF",
      descSubProdCurta: "TOTAL",
      tipoTarifa: {
        id: 21,
        idTarifa: 2,
        descTarifaLonga: "MENSALIDADE PRE",
        descTarifaCurta: "MENSALIDADE PRE"
      },
      tipoPessoa: {
        id: 1,
        descTipoPessoaPermitidaSubProdLonga: "Pessoa Física",
        nemotecnicoTipoPessoaPermitidaSubProd: "INDIVIDUAL",
        descTipoPessoaPermitidaSubProdCurta: "Pessoa Física"
      }
    },
    {
      percentualDescontoTarifa: 100,
      valorFixoDescontoTarifa: null,
      numeroMesesBonificacao: 9,
      descSubProdLonga: "TOTAL POS PF",
      codSubProduto: "011",
      qtdContasDireitoUtilizarCodPromo: null,
      dataInicialValidadeCodPromo: "20190704000000000",
      dataFinalValidadeCodPromo: "20500703000000000",
      pacoteDefaultBonificacaoSubProd: false,
      descBonificacaoLonga: "BB VAREJO 9 MESES",
      codPromocional: "VELOEBBVARPOS",
      descBonificacaoCurta: "BB VAREJO",
      descSubProdCurta: "TOTAL",
      tipoTarifa: {
        id: 102,
        idTarifa: 11,
        descTarifaLonga: "MENSALIDADE POS",
        descTarifaCurta: "MENSALIDADE POS"
      },
      tipoPessoa: {
        id: 1,
        descTipoPessoaPermitidaSubProdLonga: "Pessoa Física",
        nemotecnicoTipoPessoaPermitidaSubProd: "INDIVIDUAL",
        descTipoPessoaPermitidaSubProdCurta: "Pessoa Física"
      }
    }
  ],
  mainBonus: 9,
  regulamento: {
    validity: '',
    title: '',
    content: '',
  },
  codigomgm: getUrlVars()["codigomgm"]  
};

const AppContext = createContext(initialState);
const { Provider } = AppContext;

const ACTIONS = {
  SET_LOADING: "setLoading",
  SET_PLANS: "setPlans",
  SET_MAIN_BONUS: "setMainBonus",
  SET_REGULAMENTO: "setRegulamento",
};

const StateProvider = ({ children }) => {
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case ACTIONS.SET_LOADING:
        return {
          ...state,
          loading: action.payload
        };

      case ACTIONS.SET_PLANS:
        return {
          ...state,
          plans: action.payload
        };

      case ACTIONS.SET_MAIN_BONUS:
        return {
          ...state,
          mainBonus: action.payload
        };

      case ACTIONS.SET_REGULAMENTO:
        return {
          ...state,
          regulamento: action.payload,
        };
      default:
        throw new Error();
    }
  }, initialState);

  function openPromotion(type) {
    return function() {
      let url = FC_FLOW_PRE_URL;
      let code = PROMO_CODE_PRE;
      if (type === "POS") {
        url = FC_FLOW_POS_URL;
        code = PROMO_CODE_POS;
      }
      window.location.href = (state.codigomgm ? `${url}?origem=lp&codigo=${code}&codigomgm=${state.codigomgm}` : `${url}?origem=lp&codigo=${code}`);
      
    };
  }

  return (
    <Provider value={{ state, dispatch, openPromotion }}>{children}</Provider>
  );
};

function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
      vars[key] = value;
  });
  return vars;
}

export { AppContext, StateProvider, ACTIONS };
